import { PerformanceDatapoint } from 'owa-analytics';
import type { TableView } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-mail-store';
import {
    getMailListLoadDatapointContext,
    isMailListLoadGenerationEnabled,
    setMailListLoadDatapoint,
} from './mailListLoadDatapointGetterAndSetter';
import endMailListLoadDatapoint from './endMailListLoadDatapoint';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';

let eventTimestamp: number | undefined = undefined;

export function setInteractionTimestamp(timeStamp?: number): void {
    eventTimestamp = timeStamp;
}

export function createMailListLoadDatapoint(
    actionSource: ActionSource,
    tableView: TableView,
    owningSwitchMailFolderDatapoint?: PerformanceDatapoint
): number {
    // End the previous MLL datapoint if it did not complete before a new ML load.
    const currentContext = getMailListLoadDatapointContext();
    if (currentContext) {
        endMailListLoadDatapoint(
            'None' /*componentRendered*/,
            currentContext.tableViewId,
            currentContext.loadId,
            true /* shouldInvalidate */,
            undefined /* overrideStatus */,
            undefined /* error */
        );
    }

    const options = {
        timeout: 90 * 1000,
        eventTimestamp,
    };

    const mailboxInfo = getMailboxInfo(tableView);
    const mllDp = new PerformanceDatapoint('MailListLoad', mailboxInfo, options);
    mllDp.addCustomData({ act: actionSource });
    return setMailListLoadDatapoint(mllDp, tableView.id, owningSwitchMailFolderDatapoint);
}

export function invalidateMailListLoadForSwitch(
    abandonedSwitchMailFolderDatapoint: PerformanceDatapoint
): void {
    if (!isMailListLoadGenerationEnabled()) {
        return;
    }

    const currentContext = getMailListLoadDatapointContext();
    if (currentContext?.owningSwitchMailFolderDatapoint === abandonedSwitchMailFolderDatapoint) {
        endMailListLoadDatapoint(
            'None' /* componentRendered */,
            currentContext.tableViewId,
            currentContext.loadId,
            true /* shouldInvalidate */
        );
    }
}
